import React from "react";
import {Box, Typography} from "@mui/material";
import {Helmet} from "react-helmet";
  
 var Build = '__Build.BuildNumber__';

const Version = () => {

  return (
    <Box>
        <Helmet>
            <title>PairCare - Version Details</title>
        </Helmet>
      <Typography variant={"h6"} align={"center"}>
        Build #: {Build}
      </Typography>
    </Box>
  );
};
  
export default Version;